<div class="p-relative flex justify-between">
    <div class="flex justify-start a-center">
        <h5 mat-dialog-title>Настройки распределения заявок</h5>
        <mat-icon class="mrt-0-4" [appCustomTooltip]="descriptionTooltip">info</mat-icon>
    </div>
    <app-close-button [dialogRef]='dialogRef'/>
</div>
@if (loading()) {
    <app-loader [isLoading]="loading()"/>
} @else {
    <mat-dialog-content class="pd-1">
        <mat-form-field class="w-100" appearance="outline">
            <mat-label>Коэффициент увеличения/уменьшения времени работ</mat-label>
            <input matInput
                   type="number"
                   [(ngModel)]="percentageValue"
                   min="0"
                   max="2"
                   step="0.1"
                   placeholder="Введите процент увеличения времени">
            <mat-hint>Введите коэффициент от 0 до 2</mat-hint>
            @if (percentageValue < 0 || percentageValue > 2) {
                <mat-error>Введите значение от 0 до 2</mat-error>
            }
        </mat-form-field>
        <mat-checkbox [(ngModel)]="balanceWorkload">Равномерная загрузка работников с учетом времени</mat-checkbox>
        <mat-checkbox [(ngModel)]="assignAllTasks">Равномерное распределение всех заявок (по кол-ву)</mat-checkbox>
        <mat-checkbox [(ngModel)]="assignAllTasksByDuration">Равномерное распределение всех заявок (по длительности)</mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-flat-button [disabled]="percentageValue < 0 || percentageValue > 2" (click)="onSubmit()" data-testid="assign-orders-button">Распределить</button>
    </mat-dialog-actions>
}
